import { Button, ButtonGroup } from '@shopify/polaris';
import { FallbackRate } from './api';
import { DataTableRow } from '../../../shared/components/DataTable';

export interface FallbackRateRowHandlers {
  onEdit: (rate: FallbackRate) => void;
  onDelete: (rate: FallbackRate) => void;
}

export function fallbackRateToRow(
  rate: FallbackRate,
  handlers: FallbackRateRowHandlers,
): DataTableRow {
  return {
    id: rate.id,
    cells: [
      rate.shop?.domain ?? rate.shopId,
      rate.postcodePattern,
      `${rate.minWeightG}–${rate.maxWeightG} g`,
      `${(rate.priceMinorUnits / 100).toFixed(2)} ${rate.currency}`,
      rate.serviceName,
      <ButtonGroup key={`actions-${rate.id}`}>
        <Button onClick={() => handlers.onEdit(rate)}>Edit</Button>
        <Button tone="critical" onClick={() => handlers.onDelete(rate)}>
          Delete
        </Button>
      </ButtonGroup>,
    ],
  };
}
